import React, { useEffect, useState } from "react";
import { Avatar, Button, Col, Input, Row, Select, Divider } from "antd";
import { EqMessageType } from "../../../shared/enums";
import { EqInput } from "../../../custom/eqInput/EqInput";
import { ISelectProps } from "../../../shared/Interfaces";
import EqSelect from "../../../custom/eqSelect/EqSelect";
import EqButton from "../../../custom/eqButton/EqButton";
import {
  getDefaultImage,
  imageType,
  openNotificationWithIcon,
} from "../../../shared/Common";
import { faReply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./EqMessageReply.scss";
import moment from "moment";
import { useAuthState } from "../../../context/Context";

const { Option } = Select;

interface EqMessageReplyFormProps {
  message: any;
  onCreateReply: (message: any, reply: any) => void;
}

const EqMessageReply: React.FC<EqMessageReplyFormProps> = ({
  message,
  onCreateReply,
}) => {
  const userDetails: any = useAuthState();

  const [showReplies, setShowReplies] = useState(false);
  const [replyText, setReplyText] = useState("");

  const handleToggleReplies = () => {
    setShowReplies(!showReplies);
  };

  useEffect(() => {
    if(message){
      
      console.log(message)
    }
  }, [message]);
  const handleReply = () => {
    if (replyText.trim() !== "") {
      // Perform any necessary logic before sending the reply
      onCreateReply(message, replyText);
      setReplyText("");
    } else {
      openNotificationWithIcon("Error", "Please enter a valid reply text");
    }
  };

  return (
    <div className="eq-MessageReply">
      {/* Display message details */}
      <Row justify="space-between">
        <Col span={22}>
          <Row gutter={8}>
            <Col>
              <Avatar
                size={40}
                src={
                  message.sender
                    ? message.sender.userImage?.url
                    : getDefaultImage(imageType.trainer)
                }
              />
            </Col>
            <Col>
              <strong>
                {message.sender
                  ? message.sender.firstName + message.sender.firstName
                  : ""}
              </strong>
              <div>{message.sender ? message.sender.email : ""}</div>
            </Col>
          </Row>

          <Row className="message-text">
            <Col span={23} offset={1}>
              {message.message}
            </Col>
          </Row>
        </Col>

        <Col span={2}>
          {/* <FontAwesomeIcon icon={faReply} onClick={handleToggleReplies} /> */}
          {moment(message.createOn).format("hh:mm A")}
        </Col>
      </Row>
      <Row>
        <Col span={22} offset={1}>
          {/* Display message text */}
          {/* <p>{message.message}</p> */}

          {/* Button to toggle replies visibility */}
          <div className="toggle-replies">
            <a onClick={handleToggleReplies}>
              {showReplies ? "Hide Replies" : "Show Replies"}
            </a>
          </div>

          {/* Existing replies section */}
          {showReplies && (
            <div className="existing-replies">
              {/* Loop through existing replies and display them */}
              {message.messageReplies.map((reply: any) => (
                <div key={reply.id} className="reply-item">
                  <Row justify="space-between">
                    <Col span={22}>
                      <Row gutter={8}>
                        <Col>
                          <Avatar
                            size={40}
                            src={
                              reply.sender?.userImage?.url ||
                              getDefaultImage(imageType.trainer)
                            }
                          />
                        </Col>
                        <Col>
                          <strong>
                            {reply.sender?.firstName} {reply.sender?.lastName}
                          </strong>
                          <div>{reply.sender ? reply.sender.email : ""}</div>
                        </Col>
                      </Row>
                      <Row className="reply-text">
                        <Col span={23} offset={1}>
                          {reply.reply}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={2}>
                      {/* <FontAwesomeIcon icon={faReply} onClick={handleToggleReplies} /> */}
                      {moment(reply.sentOn).format("hh:mm A")}
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          )}

          {/* Reply box */}
          {/* <div className="reply-box">
            <EqInput
              placeholder="Type your reply here..."
              value={replyText}
              onChange={(e: any) => setReplyText(e.target.value)}
            />
            <EqButton type="primary" onClick={handleReply}>
              Reply
            </EqButton>
          </div> */}

          <div className="reply-box">
            <Row >
              <Col span={2}>
                <Avatar
                  size={40}
                  src={
                    userDetails?.imageUrl ||
                    getDefaultImage(imageType.trainer)
                  }
                />
              </Col>
              <Col span={20} className="reply-input-container">
              <span><FontAwesomeIcon icon={faReply}/> {message?.sender?.email}</span>

                <Input.Group compact>
                  <EqInput
                    className="reply-textarea"
                    style={{ border: "none" }}
                    placeholder="Type your reply here..."
                    value={replyText}
                    onChange={(e: any) => setReplyText(e.target.value)}
                    
                  />
                  <EqButton type="primary" onClick={handleReply}>
                    Reply
                  </EqButton>
                </Input.Group>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EqMessageReply;
